export enum SymbolCloseIntervalTypeEnum {
    AllTime = 'allTime',
    LastTwelveMonths = 'lastTwelveMonths',
    ThisYearBeginning = 'thisYearBeginning',
    ThisMonthBeginning = 'thisMonthBeginning',
    LastThirtyDays = 'lastThirtyDays',
}
